import { render, staticRenderFns } from "./client-list.vue?vue&type=template&id=0b067cdc&scoped=true&"
import script from "./client-list.vue?vue&type=script&lang=js&"
export * from "./client-list.vue?vue&type=script&lang=js&"
import style0 from "./client-list.vue?vue&type=style&index=0&id=0b067cdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b067cdc",
  null
  
)

component.options.__file = "client-list.vue"
export default component.exports